import { useTranslation } from 'react-i18next'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

const OPTIONS = ['allStatuses', 'enrolled', 'eligible', 'actionNeeded', 'ineligible']

type UserProgramStatusPickerProps = {
  value: string
  onChange(status: string): void
}

export const UserProgramStatusPicker = ({ value = '', onChange }: UserProgramStatusPickerProps) => {
  const { t } = useTranslation('impact/UserProgramsList/UserProgramStatusPicker')

  const handleChange = (event: SelectChangeEvent) => {
    const newStatus = event.target.value as string

    onChange(newStatus)
  }

  return (
    <Select value={value} onChange={handleChange}>
      {OPTIONS.map(option => (
        <MenuItem key={option} value={option}>
          {t(`option_${option}`)}
        </MenuItem>
      ))}
    </Select>
  )
}
